import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-deviations',
  templateUrl: './deviations.component.html',
  styleUrls: ['./deviations.component.css']
})
export class DeviationsComponent implements OnInit {
    argType;

    argValue;

    public itemsListDeviations: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.argType = this.stateService.getStateParams()['argtype'];
        this.argValue = this.stateService.getStateParams()['argvalue'];
    }

    private async loadDeviations() {
        if (!!this.argType && !!this.argValue) {
            this.itemsListDeviations = await this.datatask.Post(318, {
                argtype: this.argType,
                argvalue: this.argValue
            });
        }
    }

    public async goToFunc(state: any) {
        switch (state) {
            case 'deviation':
                const response = (await this.datatask.Post(320))[0];

                this.stateService?.go('deviation', {
                    argtype: this.argType,
                    argvalue: this.argValue,
                    custact_no_deviation: response?.custact_no
                });
                break;
            default:
                break;
        }
    }

    private async init() {
        this.loadDeviations();
    }

    ngOnInit() {
        this.init();
    }
}
